import {styled} from '@mui/material/styles';
import {ListItemButton} from '@mui/material';
import Autocomplete, {autocompleteClasses} from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import InputBase from '@mui/material/InputBase';
import Popper from '@mui/material/Popper';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import RedotCircleFlag from './RedotCircleFlag';
import {useTranslation} from 'react-i18next';

const StyledAutocompletePopper = styled('div')(({theme}) => ({
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: 'none',
    margin: 0,
    color: 'inherit',
    fontSize: 13,
  },
  [`& .${autocompleteClasses.listbox}`]: {
    padding: 0,
    [`& .${autocompleteClasses.option}`]: {
      minHeight: 'auto',
      alignItems: 'flex-start',
      padding: 8,
      borderBottom: '1px solid #eaecef',
    },
  },
  [`&.${autocompleteClasses.popperDisablePortal}`]: {
    position: 'relative',
  },
}));

const OptionItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  margin: '5px 0',
  '.name': {
    paddingLeft: 6,
  }
}));

function PopperComponent(props) {
  const {disablePortal, anchorEl, open, ...other} = props;
  return <StyledAutocompletePopper {...other} />;
}

PopperComponent.propTypes = {
  anchorEl: PropTypes.any,
  disablePortal: PropTypes.bool,
  open: PropTypes.bool.isRequired,
};

const StyledPopper = styled(Popper)(({theme}) => ({
  border: '1px solid #e1e4e8',
  borderRadius: 6,
  width: 350,
  zIndex: theme.zIndex.modal,
  fontSize: 14,
  backgroundColor: '#fff',
}));

const StyledInput = styled(InputBase)(({theme}) => ({
  padding: 10,
  width: '100%',
  '& input': {
    borderRadius: 4,
    padding: 8,
    fontSize: 14,
    border: '1px solid #E41C3E',
    '&:focus': {
      boxShadow: '0px 0px 0px 3px #FBD4CC',
    },
  },
}));

export default function NationListPopover({list, anchorEl, onClose, onChange}) {
  const {t} = useTranslation();

  const handleClose = () => {
    if (onClose) onClose();
  };

  const open = Boolean(anchorEl);

  const onSelect = function (val) {
    if (onChange) onChange(val);
    handleClose();
  };

  return (
    <React.Fragment>
      <StyledPopper open={open} anchorEl={anchorEl} placement="bottom-start">
        <ClickAwayListener onClickAway={handleClose}>
          <div>
            <Box
              sx={{
                borderBottom: '1px solid #eaecef',
                padding: '8px 10px',
                fontWeight: 600,
              }}
            >
              {t('nation_list')}
            </Box>
            <Autocomplete
              open
              onClose={(event, reason) => {
                if (reason === 'escape') {
                  handleClose();
                }
              }}
              // value={pendingValue}
              // disableCloseOnSelect
              PopperComponent={PopperComponent}
              // noOptionsText="No labels"
              renderOption={(props, option) => {
                return (
                  <ListItemButton key={option.id} onClick={() => onSelect(option)}>
                    <OptionItem>
                      <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <RedotCircleFlag code={option.code}/>
                        <span className='name'>{option.name}</span>
                      </Box>
                      <span>{option.areaCode}</span>
                    </OptionItem>
                  </ListItemButton>
                )
              }}
              options={list || []}
              getOptionLabel={(option) => `${option.name},${option.enName},${option.code3},${option.areaCode}`}
              renderInput={(params) => (
                <StyledInput
                  ref={params.InputProps.ref}
                  inputProps={params.inputProps}
                  autoFocus
                  placeholder={t('search')}
                />
              )}
            />
          </div>
        </ClickAwayListener>
      </StyledPopper>
    </React.Fragment>
  );
}